import { SearchTable } from '@aibees/elephant/types';
import { SearchFilterBase } from '../types';
import company from './company';
import employees from './employees';
import people from './people';

export const filterConfigs: Record<SearchTable, SearchFilterBase[]> = {
  [SearchTable.Company]: company,
  [SearchTable.People]: people,
  [SearchTable.Employees]: employees,
  [SearchTable.BuyingTeam]: [],
  // [SearchTable.BuyingTeam]: buyingTeam,
};
